import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';

import {CollectionsBucket} from '@eb/featured-collections';

import CardBucket from '../CardBucket';
import MapBucket from '../MapBucket';
import CalendarBucket from '../CalendarBucket';
import CategoryBucket from '../CategoryBucket';
import OrganizerFollowBucket from '../organizerFollowBucket/OrganizerFollowBucket';
import NearbyCitiesBucket from '../NearbyCitiesBucket';
import TrendingSearchesBucket from '../TrendingSearchesBucket';

import {
    FEATURED_TEMPLATE,
    LARGE_CARD_TEMPLATE_3,
    LARGE_CARD_TEMPLATE_6,
    CARD_TEMPLATE_4,
    CARD_TEMPLATE_8,
    CARD_BIG,
    CALENDAR_TEMPLATE,
    COLLECTION_TEMPLATE,
    MAP_TEMPLATE,
    CATEGORY_TEMPLATE,
    NEARBY_CITIES_TEMPLATE,
    TRENDING_SEARCHES_TEMPLATE,
    SHARE_OPTIONS_PROPTYPE,
    ARTICLE_TEMPLATE,
    ORGANIZER_FOLLOW_TEMPLATE,
    EXPERIMENTS_SHAPE_PROP_TYPE,
} from '../../constants';

export const BUCKET_LOOKUP_MAP = {
    [FEATURED_TEMPLATE]: CardBucket,
    [LARGE_CARD_TEMPLATE_3]: CardBucket,
    [LARGE_CARD_TEMPLATE_6]: CardBucket,
    [CARD_TEMPLATE_4]: CardBucket,
    [CARD_TEMPLATE_8]: CardBucket,
    [CARD_BIG]: CardBucket,
    [CALENDAR_TEMPLATE]: CalendarBucket,
    [MAP_TEMPLATE]: MapBucket,
    [CATEGORY_TEMPLATE]: CategoryBucket,
    [NEARBY_CITIES_TEMPLATE]: NearbyCitiesBucket,
    [ARTICLE_TEMPLATE]: CardBucket,
    [TRENDING_SEARCHES_TEMPLATE]: TrendingSearchesBucket,
    [COLLECTION_TEMPLATE]: CollectionsBucket,
    [ORGANIZER_FOLLOW_TEMPLATE]: OrganizerFollowBucket,
};

const DecorativeImage = ({decorationPlacement, decorativeImage}) => {
    let component = null;

    if (decorativeImage) {
        const classes = classNames(
            'decorative-image',
            `decorative-image--${decorationPlacement.position}`,
            decorationPlacement.classes
        );
        const parentClasses = classNames(
            'decorative-image--container',
            decorationPlacement.parentClasses
        );

        component = (
            <div className={parentClasses}>
                <img className={classes} src={decorativeImage} alt="" />
            </div>
        );
    }

    return component;
};

const removeImageUrl = (event) => ({
    ...event,
    imageUrl: undefined,
});

export default class StyledBucket extends React.Component {
    static propTypes = {
        allEventsUrl: PropTypes.string,
        bucketKey: PropTypes.string,
        bucketWrapperClasses: PropTypes.string,
        currentPlace: PropTypes.string,
        containerClasses: PropTypes.string,
        //eslint-disable-next-line
        content: PropTypes.arrayOf(PropTypes.object),
        //eslint-disable-next-line
        decorationPlacement: PropTypes.object,
        decorativeImage: PropTypes.string,
        experiments: EXPERIMENTS_SHAPE_PROP_TYPE,
        httpReferer: PropTypes.string,
        isAuthenticated: PropTypes.bool,
        linkUrl: PropTypes.string,
        locationSlug: PropTypes.string,
        name: PropTypes.string,
        onSaveEvent: PropTypes.func,
        onTrackEventClickInternal: PropTypes.func,
        shareOptions: SHARE_OPTIONS_PROPTYPE,
        template: PropTypes.string,
        trackLocationChange: PropTypes.func,
        trackGAEvent: PropTypes.func,
        trackGAEventOnPageUnload: PropTypes.func,
        type: PropTypes.string,
        userCollections: PropTypes.arrayOf(PropTypes.object),
        onAddOrRemoveEventToCollection: PropTypes.func,
        onCreateCollection: PropTypes.func,
    }

    state = {
        visible: false,
    }

    _handleWaypointEnter = () => {
        this.setState({visible: true});
    }

    render() {
        const {
            containerClasses,
            bucketWrapperClasses,
            decorationPlacement,
            decorativeImage,
            currentPlace,
            content,
            name,
            type,
            template,
            onSaveEvent,
            shareOptions,
            isAuthenticated,
            trackLocationChange,
            trackGAEvent,
            trackGAEventOnPageUnload,
            onTrackEventClickInternal,
            allEventsUrl,
            httpReferer,
            locationSlug,
            experiments,
            featureFlags,
            userCollections,
            onAddOrRemoveEventToCollection,
            onCreateCollection,
            userId,
            gaCategory,
            gaActionSuffix,
            gaSettings,
            organizers,
            bucketKey,
            seeMore = {},
        } = this.props;
        const {visible} = this.state;
        const {url: linkUrl} = seeMore;
        let bucketComponent = null;
        let DynamicBucket = BUCKET_LOOKUP_MAP[template];
        let updatedContent = content;

        //eslint-disable-next-line
        if (!visible && type !== 'follow_organizer') {
            updatedContent = content.map(removeImageUrl);
        }

        bucketComponent = (
            <div className={containerClasses} key={bucketKey}>
                <div className={bucketWrapperClasses}>
                    <DecorativeImage
                        decorationPlacement={decorationPlacement}
                        decorativeImage={decorativeImage}
                    />
                    <DynamicBucket
                        userId={userId}
                        gaCategory={gaCategory}
                        gaActionSuffix={gaActionSuffix}
                        gaSettings={gaSettings}
                        organizers={organizers}
                        currentPlace={currentPlace}
                        content={updatedContent}
                        name={name}
                        type={type}
                        template={template}
                        linkUrl={linkUrl}
                        onSaveEvent={onSaveEvent}
                        shareOptions={shareOptions}
                        isAuthenticated={isAuthenticated}
                        trackLocationChange={trackLocationChange}
                        trackGAEvent={trackGAEvent}
                        trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                        onTrackEventClickInternal={onTrackEventClickInternal}
                        bucketKey={bucketKey}
                        allEventsUrl={allEventsUrl}
                        httpReferer={httpReferer}
                        locationSlug={locationSlug}
                        experiments={experiments}
                        featureFlags={featureFlags}
                        userCollections={userCollections}
                        onAddOrRemoveEventToCollection={onAddOrRemoveEventToCollection}
                        onCreateCollection={onCreateCollection}
                    />
                </div>
            </div>
        );

        return (
            <Waypoint
                onEnter={this._handleWaypointEnter}
            >
                {bucketComponent}
            </Waypoint>
        );
    }
}
